import React from 'react';
import { Card, Table, Tag } from 'antd';
import { useNavigate } from 'react-router-dom';
import type { WorkstationControlCenterQueryParams } from '@/services/workstationControlCenter.service';
import { useWccInspection } from '@/hooks/useWorkstationControlCenter';

interface Props {
  params?: WorkstationControlCenterQueryParams;
}

const InspectionDependencyPanel: React.FC<Props> = ({ params }) => {
  const navigate = useNavigate();
  const { data, isLoading } = useWccInspection(params);
  const rows = (data as { rows?: Record<string, unknown>[] })?.rows ?? [];

  return (
    <Card id="inspection" title="Inspection dependency" style={{ marginTop: 16 }}>
      <Table
        size="small"
        loading={isLoading}
        rowKey={(r, i) => `${r.work_order_number}-${i}`}
        dataSource={rows}
        onRow={(r) => ({
          onClick: () => r.deepLink && navigate(String(r.deepLink)),
          style: { cursor: 'pointer' },
        })}
        columns={[
          { title: 'Workstation', dataIndex: 'workstation_name' },
          { title: 'WO', dataIndex: 'work_order_number' },
          { title: 'Type', dataIndex: 'inspection_type', width: 70 },
          { title: 'Operation', dataIndex: 'operation' },
          { title: 'Inspector', dataIndex: 'inspector_name' },
          { title: 'Category', dataIndex: 'category', render: (c: string) => <Tag>{c}</Tag> },
          { title: 'Status', dataIndex: 'status' },
        ]}
        pagination={{ pageSize: 10 }}
      />
    </Card>
  );
};

export default InspectionDependencyPanel;
